import React, { memo } from 'react';

import { getLiteral } from 'utils/getLiteral';

import RatesSectionBlock from './RatesSectionBlock';

const RatesGeneralInfoHeader = memo(() => (
    <RatesSectionBlock
        advice={getLiteral('helptext_info_rates')}
        title={getLiteral('label_info_rates')}
    />
));

RatesGeneralInfoHeader.displayName = 'RatesGeneralInfoHeader';

export default RatesGeneralInfoHeader;
